import ComponentManager from '@/Management/ComponentManager';
import SwitchViewModelType from '@/Components/Switch/SwitchViewModel';
import SwitchType from '@/Components/Switch/Switch';
import CheckBoxFactory from '@/Factories/ControlFactories/CheckBoxFactory';

export default class SwitchFactory extends CheckBoxFactory {

    /**
     *  @override
     */
    control: SwitchType;
    private SwitchViewModel = ComponentManager.getViewModel<typeof SwitchViewModelType>('SwitchViewModel');
    private Switch = ComponentManager.getControl<typeof SwitchType>('Switch');

    /**
     *  @override
     */
    public viewModel: SwitchViewModelType;
    protected jQueryControl: JQuery<HTMLElement>;

    public constructor(params) {
        super(params);
    }

    protected createViewModel(parameter: any): SwitchViewModelType {
        return new this.SwitchViewModel(parameter);
    }

    protected createControl(viewModel: SwitchViewModelType): SwitchType {
        return new this.Switch(viewModel);
    }
}

ComponentManager.setFactory('Switch', SwitchFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');